const generatePayload = (newItems, mapper) => {
  const map = new Function('newItems', mapper);
  return map(newItems);
};

const addToCard = async (cartItems, clientSideMethod) => {
  const map = new Function('cartItems', `{return ${clientSideMethod}}`);
  return await map(cartItems);
};

export default { addToCard, generatePayload };
